import { Legend } from '../../../../../common/chart/legend'
import { Element } from '../../../../../common/html/element'
import { formatText } from '../../../../../helpers/value'
import { COLORS } from './constants'

export const LegendCommon = ({ firstItem, listIndexOfLineKeys }) => {
  return (
    <Legend
      style={{ marginRight: 16 }}
      className="flexColumn"
      items={[
        {
          title: formatText(firstItem.name0),
          iconCustom: true,
          color: '#006AA6',
          isEllipsis: true,
          isI18n: false,
          renderCustomIcon: () => {
            return (
              <Element
                style={{
                  height: 14,
                  width: 14,
                  backgroundColor: '#006AA6',
                  cursor: 'default',
                }}
              />
            )
          },
        },
        ...listIndexOfLineKeys.map((item) => {
          return {
            title: formatText(firstItem['name' + item]),
            iconCustom: true,
            color: COLORS[item],
            isEllipsis: true,
            isI18n: false,
            renderCustomIcon: () => {
              return (
                <Element
                  style={{
                    height: 4,
                    width: 14,
                    backgroundColor: COLORS[item],
                    cursor: 'default',
                  }}
                />
              )
            },
          }
        }),
      ]}
    />
  )
}
